import { Component, OnInit, PLATFORM_ID, Renderer2, DOCUMENT, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@teamfoster/sdk/icon';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [RouterLink, IconComponent, FromDictionaryPipe],
})
export class FooterComponent implements OnInit {
  private document = inject(DOCUMENT);
  private renderer = inject(Renderer2);
  private platformId = inject(PLATFORM_ID);

  contrast = false;
  currentYear: number = new Date().getFullYear();

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    if (localStorage.getItem('contrastMode')) {
      this.contrastMode(true);
    }
  }

  contrastMode(on: boolean = false) {
    if (on) {
      localStorage.setItem('contrastMode', '1');
      this.renderer.addClass(this.document.body, 'theme-contrast');
      this.renderer.addClass(this.document.body, 'theme');
      this.contrast = true;

      return;
    }

    if (this.contrast) {
      this.renderer.removeClass(this.document.body, 'theme-contrast');
      this.renderer.removeClass(this.document.body, 'theme');

      localStorage.removeItem('contrastMode');
      this.contrast = false;
    } else {
      this.renderer.addClass(this.document.body, 'theme-contrast');
      this.renderer.addClass(this.document.body, 'theme');
      localStorage.setItem('contrastMode', '1');
      this.contrast = true;
    }
  }
}
